import { render, staticRenderFns } from "./DialogAddonGroup.vue?vue&type=template&id=2315181c&scoped=true&"
import script from "./DialogAddonGroup.vue?vue&type=script&lang=js&"
export * from "./DialogAddonGroup.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=2315181c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2315181c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2315181c')) {
      api.createRecord('2315181c', component.options)
    } else {
      api.reload('2315181c', component.options)
    }
    module.hot.accept("./DialogAddonGroup.vue?vue&type=template&id=2315181c&scoped=true&", function () {
      api.rerender('2315181c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Products/DialogAddonGroup.vue"
export default component.exports